import { useEffect, useState, useRef } from 'react';
import { isEmpty, isEmail, right } from '@Views/utils/StringUtils';
import { callService } from '@Views/utils/ServiceUtils';

import DaumPostcode from 'react-daum-postcode';
import DatePicker from '@Views/comp/DatePicker';

const EmploymentWrite1 = ({ msg, history, setPageNo, pageNo, svyrEmplyPbanNo, svyrEmplySpprrDetail }: any) => {

    const [hopStDate, setHopStDate] = useState<any>();
    const [hopEndDate, setHopEndDate] = useState<any>();
    const [bthDate, setBthDate] = useState<any>();
    const [postCodePopupActive, setPostCodePopupActive] = useState<boolean>(false);

    const svyrNmRef: any = useRef();
    const strnmZpcdRef: any = useRef();
    const strnmAddrRef: any = useRef();
    const strnmDtlAddrRef: any = useRef();
    const telno2Ref: any = useRef();
    const telno3Ref: any = useRef();
    const cntctEaddrRef: any = useRef();

    const win: any = window;

    let [termsPopupActive, setTermsPopupActive] = useState<boolean>(false);
    let [mdtyInfoUtlzCnsnYn, setMdtyInfoUtlzCnsnYn] = useState<boolean>();
    let [slctInfoUtlzCnsnYn, setSlctInfoUtlzCnsnYn] = useState<boolean>();

    // const mdtyInfoUtlzCnsnYnRef: any = useRef();
    // const slctInfoUtlzCnsnYnRef: any = useRef();

    const onClickPostcode = () => {
        setPostCodePopupActive(!postCodePopupActive);
    }

    const themeObj = {
        bgColor: '#FFFFFF',
        pageBgColor: '#FFFFFF',
        postcodeTextColor: '#C05850',
        emphTextColor: '#222222',
    };

    const postCodeStyle = {
        width: '100%',
        height: '480px',
    };

    const completeHandler = (data: any) => {
        const { roadAddress, zonecode } = data;
        strnmZpcdRef['current']['value'] = zonecode;
        strnmAddrRef['current']['value'] = roadAddress;
        strnmDtlAddrRef['current']['value'] = '';
    };

    const closeHandler = (state: any) => {
        if (state === 'FORCE_CLOSE') {
            setPostCodePopupActive(false);
        } else if (state === 'COMPLETE_CLOSE') {
            setPostCodePopupActive(false);
        }
    };

    // const next3 = () => {

    //     if (mdtyInfoUtlzCnsnYn === false) {
    //         alert('필수 동의를 선택해주세요.');
    //         return;
    //     }

    //     if (slctInfoUtlzCnsnYn === undefined) {
    //         alert('선택 동의 여부를 선택해주세요.');
    //         return;
    //     }

    //     if (mdtyInfoUtlzCnsnYn === true && slctInfoUtlzCnsnYn === true) {
    //         svyrEmplySpprrDetail['mdtyInfoUtlzCnsnYn'] = 'Y';
    //         svyrEmplySpprrDetail['slctInfoUtlzCnsnYn'] = 'Y';
    //         setPageNo(2);
    //     }
    //     else if (mdtyInfoUtlzCnsnYn === true && slctInfoUtlzCnsnYn === false) {
    //         svyrEmplySpprrDetail['mdtyInfoUtlzCnsnYn'] = 'Y';
    //         svyrEmplySpprrDetail['slctInfoUtlzCnsnYn'] = 'N';
    //         setPageNo(3);
    //     }

    // }

    const next2 = () => {

        setPageNo(0);

    }

    const next = () => {

        if (isEmpty(hopStDate)) {
            alert("희망근무 시작기간을 입력해주세요.");
            return;
        }

        if (isEmpty(hopEndDate)) {
            alert("희망근무 종료기간을 입력해주세요.");
            return;
        }

        if (isEmpty(svyrNmRef['current']['value'])) {
            alert("성명을 입력해주세요.");
            return;
        }

        if (isEmpty(bthDate)) {
            alert("생년월일을 입력해주세요.");
            return;
        }

        if (isEmpty(strnmZpcdRef['current']['value'])) {
            alert("주소를 입력해주세요.");
            return;
        }

        if (isEmpty(strnmAddrRef['current']['value'])) {
            alert("주소를 입력해주세요.");
            return;
        }

        if (isEmpty(strnmDtlAddrRef['current']['value'])) {
            alert("주소상세를 입력해주세요.");
            return;
        }

        if (isEmpty(telno2Ref['current']['value']) || isEmpty(telno3Ref['current']['value'])) {
            alert("휴대폰 번호를 입력해주세요.");
            return;
        }
        else {
            if (telno2Ref['current']['value'].length < 4) {
                alert("휴대폰 번호를 전부 입력해주세요.");
                return;
            }

            if (telno3Ref['current']['value'].length < 4) {
                alert("휴대폰 번호를 전부 입력해주세요.");
                return;
            }

            const regExp = /^[0-9]+$/;
            if (!regExp.test(telno2Ref['current']['value'])) {
                alert("휴대폰 번호는 숫자만 입력 가능합니다.");
                return;
            }

            if (!regExp.test(telno3Ref['current']['value'])) {
                alert("휴대폰 번호는 숫자만 입력 가능합니다.");
                return;
            }
        }

        if (isEmpty(cntctEaddrRef['current']['value'])) {
            alert("E-mail을 입력해주세요.");
            return;
        }

        if (isEmail(cntctEaddrRef['current']['value']) === false) {
            alert("사용가능한 이메일이 아닙니다.");
            return;
        }

        if (strnmDtlAddrRef['current']['value'].length > 40) {
            alert("입력하신 주소상세의 길이가 40자 이상입니다.");
            return;
        }

        if (cntctEaddrRef['current']['value'].length > 50) {
            alert("입력하신 E-mail의 길이가 50자 이상입니다.");
            return;
        }

        svyrEmplySpprrDetail['svyrEmplyPbanNo'] = svyrEmplyPbanNo;
        svyrEmplySpprrDetail['hopTrmStYmd'] = hopStDate.getFullYear() + right("0" + (hopStDate.getMonth() + 1), 2) + right("0" + hopStDate.getDate(), 2);
        svyrEmplySpprrDetail['hopTrmEndYmd'] = hopEndDate.getFullYear() + right("0" + (hopEndDate.getMonth() + 1), 2) + right("0" + hopEndDate.getDate(), 2);
        svyrEmplySpprrDetail['bthymd'] = bthDate.getFullYear() + right("0" + (bthDate.getMonth() + 1), 2) + right("0" + bthDate.getDate(), 2);
        svyrEmplySpprrDetail['svyrNm'] = svyrNmRef['current']['value'];
        svyrEmplySpprrDetail['mblTelno'] = '010' + telno2Ref['current']['value'] + telno3Ref['current']['value'];
        svyrEmplySpprrDetail['strnmZpcd'] = strnmZpcdRef['current']['value'];
        svyrEmplySpprrDetail['strnmAddr'] = strnmAddrRef['current']['value'];
        svyrEmplySpprrDetail['strnmDtlAddr'] = strnmDtlAddrRef['current']['value'];
        svyrEmplySpprrDetail['cntctEaddr'] = cntctEaddrRef['current']['value'];

        let msg = '입력하신 인적사항을 확인해주세요.<br/>';
        msg += '<br/>' + '예상근무기간 : ' + (svyrEmplySpprrDetail['hopTrmStYmd'].substr(0, 4) + '.' + svyrEmplySpprrDetail['hopTrmStYmd'].substr(4, 2) + '.' + svyrEmplySpprrDetail['hopTrmStYmd'].substr(6, 2));
        msg += ' ~ ' + (svyrEmplySpprrDetail['hopTrmEndYmd'].substr(0, 4) + '.' + svyrEmplySpprrDetail['hopTrmEndYmd'].substr(4, 2) + '.' + svyrEmplySpprrDetail['hopTrmEndYmd'].substr(6, 2));
        msg += '<br/>' + '성명 : ' + svyrEmplySpprrDetail['svyrNm'];
        msg += '<br/>' + '생년월일 : ' + (svyrEmplySpprrDetail['bthymd'].substr(0, 4) + '.' + svyrEmplySpprrDetail['bthymd'].substr(4, 2) + '.' + svyrEmplySpprrDetail['bthymd'].substr(6, 2));
        msg += '<br/>' + '휴대폰 : ' + '010' + '-' + telno2Ref['current']['value'] + '-' + telno3Ref['current']['value'];
        msg += '<br/>' + 'E-mail : ' + svyrEmplySpprrDetail['cntctEaddr'];

        win.confirm(msg, async function () {
            // 기작성여부확인
            OEMPA03R01();
        });

    }

    const OEMPA03R01 = async () => {

        let param = {
            svyrEmplyPbanNo: svyrEmplySpprrDetail['svyrEmplyPbanNo'],
            svyrNm: svyrEmplySpprrDetail['svyrNm'],
            mblTelno: svyrEmplySpprrDetail['mblTelno']
        }

        let res = await callService("OEMPA03R01", param);

        if (isEmpty(res)) /* 신규작성 */ {
            next2();
        }
        else /* 기작성 */ {

            if (res['pcsDvVal'] === '0') /* 저장 */ {

                win.confirm("작성중인 지원서가 있습니다.<br/>지원서수정 메뉴로 이동하겠습니다.", async function () {
                    history.push('/Information/EmploymentUpdate');
                });

            }
            else {

                win.confirm("제출한 지원서가 있습니다.<br/>전형결과확인 메뉴로 이동하겠습니다.", async function () {
                    history.push('/Information/EmploymentConfirm');
                });
            }

        }

    }

    const onChageMdtyInfoUtlzCnsnYn = (value: any) => {

        if (!isEmpty(value)) {

            if (value['target']['id'] === 'mdtyY') {
                setMdtyInfoUtlzCnsnYn(true);
            }
            else if (value['target']['id'] === 'mdtyN') {
                setMdtyInfoUtlzCnsnYn(false);
            }
        }
    }

    const onChageSlctInfoUtlzCnsnYn = (value: any) => {

        if (!isEmpty(value)) {

            if (value['target']['id'] === 'slctY') {
                setSlctInfoUtlzCnsnYn(true);
            }
            else if (value['target']['id'] === 'slctN') {
                setSlctInfoUtlzCnsnYn(false);
            }
        }
    }

    useEffect(() => {

        if (!isEmpty(hopStDate) && !isEmpty(hopEndDate)) {

            if ((hopStDate > hopEndDate) === true) {
                alert("종료기간을 시작기간보다 뒤로 설정하세요.");
                setHopEndDate(null);
            }

        }

    }, [hopStDate, hopEndDate]);

    useEffect(() => {

        if (!isEmpty(svyrEmplySpprrDetail)) {

            // 동의
            if (!isEmpty(svyrEmplySpprrDetail['mdtyInfoUtlzCnsnYn'])) {
                if (svyrEmplySpprrDetail['mdtyInfoUtlzCnsnYn'] === 'Y') {
                    const ele: any = document.querySelector('#mdtyY');
                    ele['checked'] = true;
                }
            }
            if (!isEmpty(svyrEmplySpprrDetail['slctInfoUtlzCnsnYn'])) {
                if (svyrEmplySpprrDetail['slctInfoUtlzCnsnYn'] === 'Y') {
                    const ele: any = document.querySelector('#slctY');
                    ele['checked'] = true;
                }
            }

        }

    }, [pageNo]);

    useEffect(() => {

        if (!isEmpty(svyrEmplySpprrDetail)) {

            // 희망근무기간 시작
            if (!isEmpty(svyrEmplySpprrDetail['hopTrmStYmd'])) {
                const year = (svyrEmplySpprrDetail['hopTrmStYmd']).substr(0, 4);
                const month = (svyrEmplySpprrDetail['hopTrmStYmd']).substr(4, 2) - 1;
                const day = (svyrEmplySpprrDetail['hopTrmStYmd']).substr(6, 2);
                setHopStDate(new Date(year, month, day));
            }
            // 희망근무기간 종료
            if (!isEmpty(svyrEmplySpprrDetail['hopTrmEndYmd'])) {
                const year = (svyrEmplySpprrDetail['hopTrmEndYmd']).substr(0, 4);
                const month = (svyrEmplySpprrDetail['hopTrmEndYmd']).substr(4, 2) - 1;
                const day = (svyrEmplySpprrDetail['hopTrmEndYmd']).substr(6, 2);
                setHopEndDate(new Date(year, month, day));
            }
            // 성명
            if (!isEmpty(svyrEmplySpprrDetail['svyrNm'])) {
                svyrNmRef['current']['value'] = svyrEmplySpprrDetail['svyrNm'];
            }
            // 생년월일
            if (!isEmpty(svyrEmplySpprrDetail['bthymd'])) {
                const year = (svyrEmplySpprrDetail['bthymd']).substr(0, 4);
                const month = (svyrEmplySpprrDetail['bthymd']).substr(4, 2) - 1;
                const day = (svyrEmplySpprrDetail['bthymd']).substr(6, 2);
                setBthDate(new Date(year, month, day));
            }

            // 우편번호
            if (!isEmpty(svyrEmplySpprrDetail['strnmZpcd'])) {
                strnmZpcdRef['current']['value'] = svyrEmplySpprrDetail['strnmZpcd'];
            }

            // 주소
            if (!isEmpty(svyrEmplySpprrDetail['strnmAddr'])) {
                strnmAddrRef['current']['value'] = svyrEmplySpprrDetail['strnmAddr'];
            }

            // 주소상세
            if (!isEmpty(svyrEmplySpprrDetail['strnmDtlAddr'])) {
                strnmDtlAddrRef['current']['value'] = svyrEmplySpprrDetail['strnmDtlAddr'];
            }

            // 휴대폰 mblTelno
            if (!isEmpty(svyrEmplySpprrDetail['mblTelno'])) {
                telno2Ref['current']['value'] = svyrEmplySpprrDetail['mblTelno'].substr(3, 4);
                telno3Ref['current']['value'] = svyrEmplySpprrDetail['mblTelno'].substr(7, 4);
            }

            // 이메일
            if (!isEmpty(svyrEmplySpprrDetail['cntctEaddr'])) {
                cntctEaddrRef['current']['value'] = svyrEmplySpprrDetail['cntctEaddr'];
            }

        }

    }, [svyrEmplySpprrDetail]);

    return (
        <>
            <div className={"modal fade" + (termsPopupActive ? ' show' : '')}>
                <div className="modal-dialog modal-dialog-centered modal-lg" style={{ height: "800px", width: "800px" }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <strong className="modal-title" id="staticBackdropLabel">개인정보 수집‧이용 안내 및 동의서</strong>
                            <button type="button" className="btn close" data-dismiss="modal" aria-label="Close" onClick={() => { setTermsPopupActive(false) }}>
                            </button>
                        </div>
                        <div className="modal-body set-height">
                            <div className="modal-comp">
                                <div className="txt-con">
                                    <div className="con-desc" style={{ maxHeight: "640px" }}>
                                        <p className="0" style={{ lineHeight: "100%", marginLeft: "7px", marginRight: "3px", textIndent: "-5.4pt", letterSpacing: "-0.2pt", fontSize: "11pt" }}><br />
                                            <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.7pt" }}>한국은행 경제통계국은 통계조사보조원 채용 및 인력관리를 위한 개인정보 수집</span>
                                            <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.7pt" }}>·</span>
                                            <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.7pt" }}>이용과 관련하여 </span>
                                            <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.7pt" }}>｢</span>
                                            <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.7pt" }}> 개인정보보호법</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.7pt" }}>｣ </span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.7pt" }}> 제</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.7pt" }}> 15</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.7pt" }}> 조 및 제</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.7pt" }}> 22</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.7pt" }}> 조에 따라 아래와 같이 개인정보를 수집</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.7pt" }}>·</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.7pt" }}> 이용하고자 합니다</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.7pt" }}>.</span></p>
                                        <p className="0" style={{ lineHeight: "100%", marginRight: "3px", fontSize: "11pt" }}> </p>
                                        <p className="0" style={{ lineHeight: "130%" }}>
                                            <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt", fontSize: "11pt" }}>■ </span>
                                            <span style={{ fontFamily: "맑은 고딕", fontWeight: "bold", fontSize: "11pt" }}> 필수 정보의 수집</span>
                                            <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt", fontWeight: "bold", fontSize: "11pt" }}>·</span>
                                            <span style={{ fontFamily: "맑은 고딕", fontWeight: "bold", fontSize: "11pt" }}> 이용 내역</span ></p >
                                        <table style={{ borderCollapse: "collapse", tableLayout: "fixed", borderWidth: "initial", borderStyle: "none", borderColor: "initial", width: "720px", margin: "5px" }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: "30%", height: "21px", padding: "1px 6px", borderWidth: "1px", borderStyle: "solid", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕", fontWeight: "bold" }}>수집목적</span></p></td>
                                                    <td style={{ width: "30%", height: "21px", padding: "1px 6px", borderWidth: "1px", borderStyle: "solid", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕", fontWeight: "bold" }}>수집</span><span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt", fontWeight: "bold" }}>·</span> <span style={{ fontFamily: "맑은 고딕", fontWeight: "bold" }}> 이용 항목</span></p ></td >
                                                    <td style={{
                                                        width: "40%", height: "21px", padding: "1px 6px", borderWidth: "1px", borderStyle: "solid", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle",
                                                    }}>
                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕", fontWeight: "bold" }}>보유 및 이용 기간</span></p ></td >
                                                </tr >
                                                <tr>
                                                    <td style={{ width: "194px", height: "85px", padding: "1px 6px", borderWidth: "1px", borderStyle: "solid", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                        <p className="0" style={{ lineHeight: "140%", marginLeft: "15px", textIndent: "-11.3pt" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>- </span><span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.3pt" }}>통계조사보조원 채용지원자</span> <span style={{ fontFamily: "맑은 고딕" }}> 본인 확인</span></p>
                                                        <p className="0" style={{ lineHeight: "140%", marginLeft: "14px", textIndent: "-10.9pt" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.6pt" }}>- </span><span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.8pt" }}> 채용철자 진행</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.8pt" }}>, </span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.8pt" }}> 채용확정 후 근로계약 체결 및 유지</span></p></td >
                                                    <td style={{ width: "168px", height: "85px", padding: "1px 6px", borderWidth: "1px", borderStyle: "solid", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                        <p className="0" style={{ lineHeight: "140%" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.3pt" }}>성명, 생년월일, 주소, 휴대폰 번호, 이메일 주소, 비밀번호</span></p>
                                                    </td >
                                                    <td style={{ width: "228px", height: "85px", padding: "1px 6px", borderWidth: "1px", borderStyle: "solid", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: " -0.3pt", fontWeight: "bold", fontSize: "11pt" }}> 채용절차 종료 후 180일까지</span></p>
                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: " -0.3pt", fontWeight: "bold", fontSize: "11pt" }}>( 전자우편으로 제출시에는 30일 이내 )</span></p>
                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}><span style={{
                                                            fontFamily: "맑은 고딕", letterSpacing: " - 0.3pt", fontWeight: "bold", fontSize: "11pt"
                                                        }}>&lt;단, 채용 확정된 지원자의 개인 정보는 고용계약 종료 후 3년까지&gt;</span ></p ></td >
                                                </tr >
                                            </tbody >
                                        </table >
                                        <p className="0" style={{ lineHeight: "130%" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.1pt" }}>※ </span><span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.1pt" }}> 귀하는 위 개인정보 수집</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.1pt" }}>·</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.1pt" }}> 이용에 동의하지 않을 권리가 있으나</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.1pt" }}>, </span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.1pt" }}> 동의하지 않을 경우 한국은행</span> <span style={{ fontFamily: "맑은 고딕" }}> 경제통계국의 통계조사보조원으로 채용될 수 없습니다</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>.</span></p>
                                        <p className="0" style={{ lineHeight: "100%", marginLeft: "26px", marginRight: "3px", textIndent: "-19.9pt", fontSize: "8pt" }}> </p>
                                        <p className="0" style={{ lineHeight: "130%", marginLeft: "26px", marginRight: "3px", textIndent: "-19.9pt", textAlign: "center", wordBreak: "keep-all", fontSize: "11pt" }}> <span style={{ fontFamily: "맑은 고딕", fontWeight: "bold", fontSize: "11pt" }}> 위 개인정보 수집</span > <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt", fontWeight: "bold", fontSize: "11pt" }}>·</span > <span style={{ fontFamily: "맑은 고딕", fontWeight: "bold", fontSize: "11pt" }}> 이용에 동의합니다.(필수) </span > <span style={{ fontFamily: "맑은 고딕", fontWeight: "bold", fontSize: "11pt", marginLeft: "35px" }}> 동의함 </span > <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt", fontWeight: "bold", fontSize: "11pt" }}><input type="radio" className="employment_radio" name="mdtyYn" id="mdtyY" onChange={onChageMdtyInfoUtlzCnsnYn} /></span> <span style={{ fontFamily: "맑은 고딕", fontWeight: "bold", fontSize: "11pt", marginLeft: "35px" }}> 동의하지 않음 </span > <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt", fontWeight: "bold", fontSize: "11pt" }}><input type="radio" className="employment_radio" name="mdtyYn" id="mdtyN" onChange={onChageMdtyInfoUtlzCnsnYn} /></span></p >
                                        <p className="0" style={{ lineHeight: "100%", marginRight: "3px" }}> </p>
                                        <p className="0" style={{ lineHeight: "130%", marginLeft: "22px", marginRight: "3px", textIndent: "-16.5pt" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt", fontSize: "11pt" }}>■ </span><span style={{ fontFamily: "맑은 고딕", fontWeight: "bold", fontSize: "11pt" }}> 선택 정보의 수집</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt", fontWeight: "bold", fontSize: "11pt" }}>·</span > <span style={{ fontFamily: "맑은 고딕", fontWeight: "bold", fontSize: "11pt" }}> 이용 내역</span ><br /></p>
                                        <table style={{ borderCollapse: "collapse", tableLayout: "fixed", borderWidth: "initial", borderStyle: "none", borderColor: "initial", width: "720px", margin: "5px" }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: "25%", height: "22px", padding: "1px 6px", borderWidth: "1px", borderStyle: "solid", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕", fontWeight: "bold" }}>수집목적</span></p></td>
                                                    <td style={{ width: "25%", height: "22px", padding: "1px 6px", borderWidth: "1px", borderStyle: "solid", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}> <span style={{ fontFamily: "맑은 고딕", fontWeight: "bold" }}>수집</span><span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt", fontWeight: "bold" }}>·</span> <span style={{ fontFamily: "맑은 고딕", fontWeight: "bold" }}> 이용 항목</span></p ></td >
                                                    < td style={{ width: "50%", height: "22px", padding: "1px 6px", borderWidth: "1px", borderStyle: "solid", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕", fontWeight: "bold" }}>보유 및 이용기간</span></p ></td >
                                                </tr >
                                                <tr>
                                                    <td style={{ width: "130px", height: "126px", padding: "1px 6px", borderWidth: "1px", borderStyle: "solid", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                        <p className="0" style={{ lineHeight: "140%" }}><span style={{ fontFamily: "맑은 고딕" }}>통계조사보조원 </span></p>
                                                        <p className="0" style={{ lineHeight: "140%" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.3pt" }}>채용 학력, 경력, 자격증 확인</span></p></td >
                                                    <td style={{ width: "164px", height: "126px", padding: "1px 6px", borderWidth: "1px", borderStyle: "solid", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                        <p className="0" style={{ lineHeight: "140%", marginLeft: "13px", textIndent: "-10pt" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.4pt" }}>- </span><span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.4pt" }}> 학력(학교, 재학기간, 학과(전공), 졸업여부)</span></p>
                                                        <p className="0" style={{ lineHeight: "140%", marginLeft: "12px", textIndent: "-9.6pt" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.4pt" }}>- </span><span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.9pt" }}> 경력(근무지, 근무기간, 직책, 담당업무)</span></p>
                                                        <p className="0" style={{ lineHeight: "140%" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.4pt" }}>- </span><span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.4pt" }}> 자격증보유현황</span></p></td >
                                                    <td style={{ width: "163px", height: "126px", padding: "1px 6px", borderWidth: "1px", borderStyle: "solid", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                        <p className="0" style={{ lineHeight: "140%", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: " -0.3pt", fontWeight: "bold", fontSize: "11pt" }}> 채용절차 종료 후 180일까지</span></p>
                                                        <p className="0" style={{ lineHeight: "140%", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: " -0.3pt", fontWeight: "bold", fontSize: "11pt" }}>( 전자우편으로 제출시에는 30일 이내 )</span></p>
                                                        <p className="0" style={{ lineHeight: "140%" }}> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.4pt", fontWeight: "bold", fontSize: "11pt" }}>&lt;단, 채용 확정된 지원자의 개인정보는 고용 계약 종료 후 3년까지&gt;</span ></p ></td >
                                                </tr >
                                            </tbody >
                                        </table >
                                        <p className="0" style={{ lineHeight: "130%" }}><span style={{ letterSpacing: "-0.1pt" }}> </span><span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.1pt" }}>※ 귀하는 위 개인정보 수집·이용에 동의하지 않을 권리가 있으나, 동의하지 않을 경우 학력, 경력, 자격증에 대해 인정받지 못할 수 있습니다.</span></p>
                                        <p className="0" style={{ lineHeight: "100%", marginLeft: "26px", marginRight: "3px", textIndent: "-19.9pt", fontSize: "8pt" }}> </p>
                                        <p className="0" style={{ lineHeight: "130%", marginLeft: "26px", marginRight: "3px", textIndent: "-19.9pt", textAlign: "center", wordBreak: "keep-all", fontSize: "11pt" }}> <span style={{ fontFamily: "맑은 고딕", fontWeight: "bold", fontSize: "11pt" }}> 위 개인정보 수집·이용에 동의합니다.(선택)</span > <span style={{ fontFamily: "맑은 고딕", fontWeight: "bold", fontSize: "11pt", marginLeft: "35px" }}> 동의함 </span > <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt", fontWeight: "bold", fontSize: "11pt" }}><input type="radio" className="employment_radio" name="slctYn" id="slctY" onChange={onChageSlctInfoUtlzCnsnYn} /></span> <span style={{ fontFamily: "맑은 고딕", fontWeight: "bold", fontSize: "11pt", marginLeft: "35px" }}>동의하지 않음</span > <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt", fontWeight: "bold", fontSize: "11pt" }}><input type="radio" className="employment_radio" name="slctYn" id="slctN" onChange={onChageSlctInfoUtlzCnsnYn} /></span></p >
                                        <p className="0" style={{ lineHeight: "100%", marginLeft: "46px", textIndent: "-34.7pt", fontWeight: "bold" }}> </p>
                                        < p className="0" style={{ lineHeight: "130%", marginLeft: "22px", marginRight: "3px", textIndent: "-16.5pt" }
                                        }><span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt", fontSize: "11pt" }}>■ </span><span style={{ fontFamily: "맑은 고딕", fontWeight: "bold", fontSize: "11pt" }}> 기타 고지사항</span></p >
                                        <table style={{ borderCollapse: "collapse", tableLayout: "fixed", borderWidth: "initial", borderStyle: "none", borderColor: "initial", width: "720px", margin: "5px" }}>
                                            < tbody >
                                                <tr>
                                                    <td style={{ width: "579px", height: "127px", padding: "1px 6px", borderWidth: "1px", borderStyle: "solid", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                        <p className="0" style={{ lineHeight: "140%" }}><span style={{ color: "rgb(255, 0, 0)" }}> </span><span style={{ fontFamily: "맑은 고딕" }}>채용합격자에 대해서는 </span><span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>「</span><span style={{ fontFamily: "맑은 고딕" }}>개인정보보호법</span><span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>」 </span><span style={{ fontFamily: "맑은 고딕" }}> 제</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}> 15</span> <span style={{ fontFamily: "맑은 고딕" }}> 조제</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}> 1</span> <span style={{ fontFamily: "맑은 고딕" }}> 항에 따라 정보주체의 동의 없이 개인정보를 수집</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>‧</span> <span style={{ fontFamily: "맑은 고딕" }}> 이용합니다</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>.</span></p>
                                                        <table style={{ borderCollapse: "collapse", tableLayout: "fixed", borderWidth: "initial", borderStyle: "none", borderColor: "initial", width: "705px" }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ width: "153px", height: "17px", padding: "1px 6px", borderWidth: "1px 1px 1px 0px", borderStyle: "solid solid solid none", borderTopColor: "rgb(0, 0, 0)", borderLeftColor: "initial", borderBottomColor: "rgb(0, 0, 0)", borderRightColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕", fontWeight: "bold" }}>처리사유</span></p></td>
                                                                    <td style={{ width: "202px", height: "17px", padding: "1px 6px", borderWidth: "1px", borderStyle: "solid", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕", fontWeight: "bold" }}>개인정보 항목</span></p ></td >
                                                                    <td style={{ width: "197px", height: "17px", padding: "1px 6px", borderWidth: "1px 0px 1px 1px", borderStyle: "solid none solid solid", borderTopColor: "rgb(0, 0, 0)", borderLeftColor: "rgb(0, 0, 0)", borderBottomColor: "rgb(0, 0, 0)", borderRightColor: "initial", verticalAlign: "middle" }}>
                                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕", fontWeight: "bold" }}>수집근거</span></p ></td >
                                                                </tr >
                                                                <tr>
                                                                    <td style={{ width: "153px", height: "24px", padding: "1px 6px", borderWidth: "1px 1px 1px 0px", borderStyle: "solid solid dotted none", borderTopColor: "rgb(0, 0, 0)", borderLeftColor: "initial", borderBottomColor: "rgb(0, 0, 0)", borderRightColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕" }}>근로계약 체결</span><span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>·</span> <span style={{ fontFamily: "맑은 고딕" }}> 유지</span></p></td >
                                                                    <td style={{ width: "202px", height: "24px", padding: "1px 6px", borderWidth: "1px", borderStyle: "solid solid dotted", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                                        < p className="0" style={{
                                                                            lineHeight: "130%", textAlign: "center", wordBreak: "keep-all"
                                                                        }}><span style={{ fontFamily: "맑은 고딕" }}>성명</span><span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>, </span> <span style={{ fontFamily: "맑은 고딕" }}> 주소</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>, </span> <span style={{ fontFamily: "맑은 고딕" }}> 연락처</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>, </span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: " - 0.2pt" }}> 계좌번호</span></p ></td >
                                                                    <td style={{ width: "197px", height: "24px", padding: "1px 6px", borderWidth: "1px 0px 1px 1px", borderStyle: "solid none dotted solid", borderTopColor: "rgb(0, 0, 0)", borderLeftColor: "rgb(0, 0, 0)", borderBottomColor: "rgb(0, 0, 0)", borderRightColor: "initial", verticalAlign: "middle" }
                                                                    }>
                                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>「</span><span style={{ fontFamily: "맑은 고딕" }}> 근로기준법</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>」 </span> <span style={{ fontFamily: "맑은 고딕" }}> 제</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}> 42</span> <span style={{ fontFamily: "맑은 고딕" }}> 조</span></p></td >
                                                                </tr >
                                                                <tr>
                                                                    <td style={{ width: "153px", height: "24px", padding: "1px 6px", borderWidth: "1px 1px 1px 0px", borderStyle: "dotted solid solid none", borderTopColor: "rgb(0, 0, 0)", borderLeftColor: "initial", borderBottomColor: "rgb(0, 0, 0)", borderRightColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕" }}>원천징수</span></p></td >
                                                                    <td style={{ width: "202px", height: "24px", padding: "1px 6px", borderWidth: "1px", borderStyle: "dotted solid solid", borderColor: "rgb(0, 0, 0)", verticalAlign: "middle" }}>
                                                                        <p className="0" style={{ lineHeight: "150%", marginLeft: "9px", textIndent: "-7.2pt", textAlign: "center", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: "-0.2pt" }}>주민등록번호</span></p></td >
                                                                    <td style={{ width: "197px", height: "24px", padding: "1px 6px", borderWidth: "1px 0px 1px 1px", borderStyle: "dotted none solid solid", borderTopColor: "rgb(0, 0, 0)", borderLeftColor: "rgb(0, 0, 0)", borderBottomColor: "rgb(0, 0, 0)", borderRightColor: "initial", verticalAlign: "middle" }}>
                                                                        <p className="0" style={{ lineHeight: "140%", textAlign: "center", wordBreak: "keep-all" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>「</span><span style={{ fontFamily: "맑은 고딕" }}> 국세기본법 시행령</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>」 </span> <span style={{ fontFamily: "맑은 고딕" }}> 제</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}> 68</span> <span style={{ fontFamily: "맑은 고딕" }}> 조 </span></p></td >
                                                                </tr >
                                                            </tbody >
                                                        </table ></td >
                                                </tr >
                                            </tbody >
                                        </table >
                                        <p><br /></p>
                                        <p className="0" style={{ lineHeight: "130%" }}><span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>※ </span><span style={{ fontFamily: "맑은 고딕" }}> 개인정보 처리에 관한 자세한 사항은 한국은행홈페이지</span> <span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}> (http://www.bok.or.kr) “</span><span style={{ fontFamily: "맑은 고딕" }}>개인정보처리방침</span><span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>”</span><span style={{ fontFamily: "맑은 고딕" }}>을 참고하시기 바랍니다</span><span style={{ fontFamily: "맑은 고딕", letterSpacing: "0pt" }}>.</span></p>
                                        <div className="btn-wrap" style={{ textAlign: "center" }}>
                                            <div className="form-group form-group-checkbox">
                                                <div className="input-box-group">
                                                    <div className="input-box">
                                                        <div className="input-group">
                                                            <button type="button" className="btn btn-popup negative" onClick={() => { setTermsPopupActive(false) }}>취소</button>
                                                            {/* <button type="button" className="btn btn-popup positive" onClick={() => { next3() }}>다음</button> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"modal-backdrop fade" + (termsPopupActive ? ' show' : '')}></div>
            {
                postCodePopupActive &&
                <div className={"modal fade show"}>
                    <div className="modal-dialog modal-dialog-centered modal-sm">
                        <div className="modal-content" style={{ height: "480px" }}>
                            <div className="modal-header">
                                <strong className="modal-title">주소찾기</strong>
                                <button type="button" className="btn close" data-dismiss="modal" aria-label="Close" onClick={() => { setPostCodePopupActive(false) }}>/
                                </button>
                            </div>
                            <div className="modal-body set-height">
                                <div className="modal-comp">
                                    <div>
                                        <DaumPostcode
                                            theme={themeObj}
                                            style={postCodeStyle}
                                            onComplete={completeHandler}
                                            onClose={closeHandler}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <div className={"modal-backdrop fade" + (postCodePopupActive ? ' show' : '')}></div>
            <div className="wrap-body-center">
                <div className="bg"></div>
                <div className="join-step" style={{ width: "550px" }}>
                    <div className="join-step-head">
                        <div className="left">
                            <h2>지원서</h2>
                        </div>
                        <div className="right">
                            <div className="step-status">
                                <ul className="clearfix">
                                    <li className="step-li active"><span className="num">1</span> <span className="step-txt">작성중</span></li>
                                    <li className="step-li"><span className="num">2</span> <span className="step-txt">작성중</span></li>
                                    <li className="step-li"><span className="num">3</span> <span className="step-txt">작성중</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="join-step-body">
                        <div className="equired">
                            <fieldset>
                                <h3><strong>1. 지원분야 - 통계조사보조원</strong></h3>
                                <div className="input-group-div" style={{ paddingTop: "13px", paddingBottom: "13px" }}>
                                    <div className="form-group" style={{ margin: "0px" }}>
                                        <div className="input-box-group">
                                            <div className="input-box input-box-btn clearfix">
                                                <label htmlFor="hopTrmStYmd" style={{ width: "200px" }}>향후 예상근무기간</label>
                                                <div className="input-group" style={{ height: "40px" }}>
                                                    <DatePicker value={hopStDate} maxDate={new Date(9998, 12, 31)} onChange={setHopStDate} format="yyyy.MM.dd" maxDetail={'month'}
                                                        onCalendarClose={() => {
                                                            let invalidEle: any = document.querySelector('input:invalid');
                                                            if (invalidEle) {
                                                                if (invalidEle['name'] === 'month') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '월 사이를 입력해주세요.');
                                                                }
                                                                if (invalidEle['name'] === 'day') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '일 사이를 입력해주세요.');
                                                                }
                                                                setHopStDate(new Date());
                                                                setTimeout(function () { setHopStDate(null) }, 100);
                                                            }
                                                        }} />
                                                    <span style={{ display: "flex", alignItems: "center" }}>&nbsp;&nbsp;&nbsp;~&nbsp;&nbsp;&nbsp;</span>
                                                    <DatePicker value={hopEndDate} maxDate={new Date(9998, 12, 31)} onChange={setHopEndDate} format="yyyy.MM.dd" maxDetail={'month'}
                                                        onCalendarClose={() => {
                                                            // const tmp = hopEndDate;
                                                            // setHopEndDate(null);
                                                            // setTimeout(function () { setHopEndDate(tmp) }, 100);
                                                            let invalidEle: any = document.querySelector('input:invalid');
                                                            if (invalidEle) {
                                                                if (invalidEle['name'] === 'month') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '월 사이를 입력해주세요.');
                                                                }
                                                                if (invalidEle['name'] === 'day') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '일 사이를 입력해주세요.');
                                                                }
                                                                setHopEndDate(new Date());
                                                                setTimeout(function () { setHopEndDate(null) }, 100);
                                                            }
                                                        }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h3><strong>2. 지원자 인적사항 - 필수항목</strong></h3>
                                <div className="input-group-div" style={{ paddingTop: "13px", paddingBottom: "13px" }}>
                                    <div className="form-group" style={{ marginBottom: "10px" }}>
                                        <div className="input-box-group">
                                            <div className="input-box clearfix">
                                                <label>성명</label>
                                                <div className="input-group">
                                                    <input className="form-control" type="text" ref={svyrNmRef} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group" style={{ marginBottom: "10px" }}>
                                        <div className="input-box-group">
                                            <div className="input-box clearfix">
                                                <label>생년월일</label>
                                                <div className="input-group" style={{ height: "40px" }}>
                                                    <DatePicker value={bthDate} maxDate={new Date(9998, 12, 31)} onChange={setBthDate} format="yyyy.MM.dd" maxDetail={'month'} clearIcon={null}
                                                        onCalendarClose={() => {
                                                            let invalidEle: any = document.querySelector('input:invalid');
                                                            if (invalidEle) {
                                                                if (invalidEle['name'] === 'month') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '월 사이를 입력해주세요.');
                                                                }
                                                                if (invalidEle['name'] === 'day') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '일 사이를 입력해주세요.');
                                                                }
                                                                setBthDate(new Date());
                                                                setTimeout(function () { setBthDate(null) }, 100);
                                                            }
                                                        }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group" style={{ marginBottom: "10px" }}>
                                        <div className="input-box-group">
                                            <div className="input-box input-box-btn">
                                                <label>주소</label>
                                                <div className="input-group">
                                                    <input className="form-control" type="text" placeholder="우편번호" ref={strnmZpcdRef} disabled />
                                                    <button type="button" className="btn" onClick={onClickPostcode}>주소찾기</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group" style={{ marginBottom: "10px" }}>
                                        <div className="input-box-group">
                                            <div className="input-box clearfix">
                                                <label></label>
                                                <div className="input-group">
                                                    <input className="form-control" type="text" placeholder="주소를 입력해주세요." ref={strnmAddrRef} disabled />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group" style={{ marginBottom: "10px" }}>
                                        <div className="input-box-group">
                                            <div className="input-box clearfix">
                                                <label></label>
                                                <div className="input-group">
                                                    <input className="form-control" type="text" placeholder="주소상세를 입력해주세요." ref={strnmDtlAddrRef} maxLength={40} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group" style={{ marginBottom: "10px" }}>
                                        <div className="input-box-group ">
                                            <div className="input-box clearfix">
                                                <label>휴대폰</label>
                                                <div className="input-group">
                                                    <input className="form-control" type="number" defaultValue="010" style={{ width: "24%" }} disabled />
                                                    <span style={{ display: "flex", alignItems: "center", width: "10%", justifyContent: "center" }}>-</span>
                                                    <input className="form-control" type="tel" maxLength={4} ref={telno2Ref} style={{ width: "28%" }} />
                                                    <span style={{ display: "flex", alignItems: "center", width: "10%", justifyContent: "center" }}>-</span>
                                                    <input className="form-control" type="tel" maxLength={4} ref={telno3Ref} style={{ width: "28%" }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group" style={{ marginBottom: "10px" }}>
                                        <div className="input-box-group">
                                            <div className="input-box clearfix">
                                                <label>E-mail</label>
                                                <div className="input-group">
                                                    <input className="form-control" type="text" placeholder="이메일을 입력해주세요." ref={cntctEaddrRef} maxLength={50} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <p className="input-guide text-important" style={{ fontSize: "14px" }}>※ 생년월일은 본인확인을 위해, 주소, 휴대폰, E-mail 등은 본인과 연락이 가능하도록 정확하게 기입</p>
                                </div>
                            </fieldset>
                        </div>

                        <div className="btn-group btn-130">
                            {/* <button type="button" className="btn btn-popup negative" onClick={() => history.push('/Employment/' + svyrEmplyPbanNo)}>취소</button> */}
                            <button type="button" className="btn btn-popup positive" onClick={next}>다음</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default EmploymentWrite1;